import axios from "axios";
import { ADMIN_TOKEN, BASE_URL } from "./constant";
import { deleteCookie, setCookie } from "../utils/utils";
// import { RemoteLogout } from "remote/Auth";

axios.defaults.baseURL = BASE_URL;

export const restoreAccessToken = () => {
  const token = localStorage.getItem("access_token");
  return token;
};

export const publicAxios = axios.create({
  baseURL: BASE_URL,
});

publicAxios.interceptors.response.use(
  function (res) {
    return res.data;
  },
  async function (err) {
    return Promise.reject(err);
  }
);

export const secureAxios = axios.create({
  baseURL: BASE_URL,

  headers: {},
});

if (localStorage.getItem("access_token")) {
  setAuthToken(localStorage.getItem("access_token"));
}

secureAxios.interceptors.response.use(
  function (res) {
    return res.data;
  },
  function (err) {
    // return Promise.reject(err);
    const originalRequest = err.config;
    if (
      (err?.response?.status === 403 || err?.response?.status === 401) &&
      !originalRequest._retry
    ) {
      ////('401 0r 403')

      //
      const token = restoreAccessToken();

      secureAxios.defaults.headers.common["Authorization"] = "Bearer " + token;

      //return secureAxios(originalRequest)
      return Promise.reject(err);
    }
    return Promise.reject(err);
  }
);

export const adminAxios = axios.create({
  baseURL: BASE_URL,

  headers: {},
});

setAdminToken(ADMIN_TOKEN);

adminAxios.interceptors.response.use(
  function (res) {
    return res.data;
  },
  function (err) {
    // return Promise.reject(err);
    const originalRequest = err.config;
    if (
      (err?.response?.status === 403 || err?.response?.status === 401) &&
      !originalRequest._retry
    ) {
      ////('401 0r 403')

      //
      const token = ADMIN_TOKEN;

      adminAxios.defaults.headers.common["Authorization"] = "Bearer " + token;

      //return secureAxios(originalRequest)
      return Promise.reject(err);
    }
    return Promise.reject(err);
  }
);

export function setAdminToken(token) {
  if (token) {
    adminAxios.defaults.headers.common["Authorization"] =
      `Bearer ${ADMIN_TOKEN}`;
  } else {
    delete adminAxios.defaults.headers.common["Authorization"];
  }
}

export function setAuthToken(token) {
  if (token) {
    secureAxios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  } else {
    delete secureAxios.defaults.headers.common["Authorization"];
  }
}

export function Logout() {
  setCookie("dayCycle", "day", 365);
  setAuthToken(null);
  localStorage.removeItem("access_token");
  localStorage.removeItem("refresh_token");
  localStorage.removeItem("clinic");
  localStorage.removeItem("ongoing_consultations");
  window.location.reload();
}

export const fitnessAxios = axios.create({
  baseURL: "https://fitness-calculator.p.rapidapi.com",
});

fitnessAxios.interceptors.response.use(
  function (res) {
    return res.data;
  },
  async function (err) {
    return Promise.reject(err);
  }
);

// export  const GetMe = async () => {
//   const [, setuserside] = useAtom(isuserside);
//   const navigate = useNavigate("/consultation");
//   await secureAxios
//     .get("users/me?fields=role.name")
//     .then((data) => {
//       // //(data.data.role.name);
//       // //("dataa----", data.data);

//       if (data?.data?.role?.name === "Patient") {
//         setuserside(true);
//         localStorage.setItem("user", "Patient");

//         navigate("/user/appointment");
//       } else if (data?.data?.role?.name === "Receptionist") {
//         localStorage.setItem("user", "receptionist");
//         navigate("/appointment");
//       } else {
//         localStorage.setItem("user", "admin");

//         navigate("/appointment");
//       }
//     })
//     .catch((err) => {
//       // //(err);
//     });
// };

export const Auth = async () => {
  await secureAxios
    .get("users/me?fields=role.name")
    .then((data) => {
      // //(data.data.role.name);
      // //("dataa----", data.data);

      return data;
    })
    .catch((err) => {
      // //(err);
    });
};

fitnessAxios.defaults.headers.common["X-RapidAPI-Key"] =
  "7dd542e34dmshf8a3bcdbf7491edp19c928jsn16b1c56b606f";
fitnessAxios.defaults.headers.common["X-RapidAPI-Host"] =
  "fitness-calculator.p.rapidapi.com";
